<template>
    <modal
            :linkClass="'action-icon'"
            :modalId="name"
            :title="title"
            :modalSize="'large'"
            :footer="true"
    >

        <template slot="modalBody">
            <div class="form-group">
                <label :for="'m-'+name+'-name-'+index">Voornaam</label>
                <input
                        v-validate="'required'"
                        :name="'m-'+name+'-firstname-'+index"
                        :id="'m-'+name+'-name-'+index"
                        type="text"
                        class="form-control"
                        v-model="value.firstName"
                />
                <span v-if="errors.first('m-'+name+'-firstname-'+index)"
                      class="small text-danger">Dit veld is verplicht</span>
            </div>
            <div class="form-group">
                <label :for="'m-'+name+'-name-'+index">Achternaam</label>
                <input
                        v-validate="'required'"
                        :name="'m-'+name+'-lastname-'+index"
                        :id="'m-'+name+'-name-'+index"
                        type="text"
                        class="form-control"
                        v-model="value.lastName"
                />
                <span v-if="errors.first('m-'+name+'-lastname-'+index)"
                      class="small text-danger">Dit veld is verplicht</span>
            </div>
            <div class="form-group">
                <label :for="'m-'+name+'-name-'+index">Geboortedatum</label>
                <input
                        :name="'m-'+name+'-birthdate-'+index"
                        :id="'m-'+name+'-birthdate-'+index"
                        type="date"
                        max="2999-12-30"
                        format="dd-MM-yyyy"
                        class="form-control placeholder-date"
                        v-model="value.birthdate"
                />
                <span v-if="errors.first('m-'+name+'-birthdate-'+index)"
                      class="small text-danger">Dit veld is verplicht</span>
            </div>

        </template>

        <div class="modal-footer" slot="modalFooter">
            <button type="button" class="btn btn-cancel" data-dismiss="modal">Annuleren</button>
            <button type="button" class="btn btn-primary" @click="validateBeforeSave">Opslaan</button>
        </div>
    </modal>
</template>

<script>
    export default {
        props: ["index", "title", "value", "name"],
        methods: {
            validateBeforeSave() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.$emit('saveChanges', this.value);
                    }
                });
            }
        },
    };
</script>
